import template from './form.html';
import nuevoDetalle from './detalle.nuevo.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import preciosI18N from 'i18n/precios/es.json';
import commonI18N from 'i18n/common/es.json';
import { formatErrorMessage } from 'core/util';
import hijoTemplate from "../../familias-productos/form/hijo.html";

export let PrecioFormComponent = {
  templateUrl: template,
  selector: 'precioForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(preciosI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', 'CustomModal'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, CustomModal) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);

  this.loadProductos = loadProductos.bind(this);
  this.loadAdicional = loadAdicional.bind(this);

  this.newDetalle = newDetalle.bind(this);
  this.editDetalle = editDetalle.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);
  this.renderProducto = renderProducto.bind(this);
  this.filterProducto = filterProducto.bind(this);
  this.onSelectAdicional = onSelectAdicional.bind(this);

  this.onSelectProducto = onSelectProducto.bind(this);
  this.renderTipoProductoAdicional = renderTipoProductoAdicional.bind(this);
  this.renderProductoAdicional = renderProductoAdicional.bind(this);

  this.generarDetalles = generarDetalles.bind(this);
  this.toggleDetalles = toggleDetalles.bind(this);

  let unsubscribe;

  const valoresFilter = Filter.path('tipo.codigo').eq('moneda');
  const adicionalDescuentoFilter = Filter.path('tipo.value').eq('Descuento');

  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.valores.reset());
    $ngRedux.dispatch(rest.actions.adicionales.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver precio'] : this.translations['Editar precio'];
      this.formEdit('precios', $stateParams.uid);
    } else {
      this.title = this.translations['Nuevo precio'];
      this.form();
    }
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));
    $ngRedux.dispatch(rest.actions.adicionales({ filter: JSON.stringify(adicionalDescuentoFilter) }));

  };

  this.localModel = {
    productosUtilizados: {},
    tiposDescuentos: [],
    tiposDescuentosMap: {},
    tiposAdicionalesMap: {},
    adicionalesUsados: {},
    productosAdicionalesUsados: {},
    productosPorAdicional: {},
    mostrarAdicionales: {},
    payloadNuevoDetalle: {},
    payloadEditDetalle: {}
  };

  this.tiposAdicionales = [];

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;

    this.model = state.form.model;

    let self = this;

    if (!this.model.id && state.valores.data && state.valores.data.length > 0) {
      this.model.moneda = state.valores.data.filter(v => v.value === 'Guaraníes')[0];
      this.monedas = state.valores.data;

      if (!this.model.detalles) {
        this.model.detalles = [];
      }

      this.localModel.tiposDescuentos = state.valores.data.filter(v => v.value === 'Guaraníes');
    } else if (this.model.id && !this.modelInit) {
      this.modelInit = true;
      this.onSelectProducto();

      this.model.detalles.forEach(function(detalle) {
        self.onSelectTipoAdicional(detalle);
        if (detalle.adicional) {
          self.onSelectAdicional(detalle);
        }
      });
    }


    if (state.adicionales.data && state.adicionales.data.length > 0 && !Object.keys(this.localModel.tiposDescuentosMap).length) {
      let tiposDescuentosMap = {};
      let self = this;
      let tiposAdicionales = this.tiposAdicionales;
      state.adicionales.data.forEach(function(element) {
        tiposDescuentosMap[element.id] = element;
        if (!self.localModel.tiposAdicionalesMap[element.id]) {
          tiposAdicionales.push({
            adicional: element,
            obligatorio: false
          });
        }
      });
      this.localModel.tiposDescuentosMap = tiposDescuentosMap;
      this.tiposAdicionales = tiposAdicionales;
    }

    return {
      form: state.form
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.precios.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.precios.list');
    }
  }

  function doSubmit() {
    let data = Object.assign({}, this.model);
    let repetidos = this.checkRepetidos();
    if (repetidos.length) {
      let msg = `Hay más de un precio para el tipo de adicional: ${repetidos.join('-')}`;
      ngNotify.set(msg, 'error');
      return;
    }

    data.producto = { id: data.producto.id };
    let detalles = [];
    data.detalles.forEach(function(detalle) {
      let dataDetalle = Object.assign({}, detalle);
      if (detalle.adicional) {
        dataDetalle.adicional = { id: detalle.adicional.id };
      }
      dataDetalle.tipoProductoAdicional = detalle.tipoProductoAdicional.id;
      detalles.push(dataDetalle);
    });

    data.detalles = detalles;

    this.save('precios', data);
  }

  this.checkRepetidos = checkRepetidos.bind(this);

  function checkRepetidos() {
    let utilizados = {};
    let repetidos = [];
    this.model.detalles.forEach(function(detalle) {
      if (detalle.tipoProductoAdicional.adicional.tipo.value !== 'Clasificador') {
        if (utilizados[detalle.tipoProductoAdicional.adicional.id]) {
          repetidos.push(detalle.tipoProductoAdicional.adicional.nombre);
        }
        utilizados[detalle.tipoProductoAdicional.adicional.id] = true;
      }
    });
    return repetidos;
  }

  function renderProducto(item) {
    return `${item.nombre} <small><strong>(${item.categoria.clase.name})</strong></small>`;
  }

  function onSelectProducto() {
    let self = this;
    let tiposAdicionalesMap = {};
    let adicionalesUsados = {};
    let productosAdicionalesUsados = {};

    if (this.model.producto.categoria.clase.value !== 'Servicio') return;

    let tiposAdicionales = this.model.producto.detalles.slice(0);
    this.model.producto.detalles.forEach(function(element) {
      tiposAdicionalesMap[element.adicional.id] = true;
      adicionalesUsados[element.adicional.id] = 0;
    });

    Object.keys(this.localModel.tiposDescuentosMap).forEach(function(element) {
      if (!tiposAdicionalesMap[element]) {
        tiposAdicionales.push({
          adicional: self.localModel.tiposDescuentosMap[element],
          obligatorio: false
        });
      }
    });
    let obligatorios = this.model.producto.detalles.filter((v) => v.obligatorio);
    this.localModel.montoBaseMinimo = 0; //obligatorios.length ? 0 : 1;

    this.localModel.tiposAdicionalesMap = tiposAdicionalesMap;
    this.tiposAdicionales = tiposAdicionales;

    if (!this.model.detalles) {
      this.model.detalles = [];
    } else {
      productosAdicionalesUsados = this.adicionalesUsuados(adicionalesUsados);
    }
    this.localModel.adicionalesUsados = adicionalesUsados;
    this.localModel.productosAdicionalesUsados = productosAdicionalesUsados;
  }

  this.adicionalesUsuados = adicionalesUsuados.bind(this);

  function adicionalesUsuados(adicionalesUsados) {
    let productosAdicionalesUsados = {};
    let adicionalesUsadosLocal = adicionalesUsados || {};

    if (!adicionalesUsados) {
      this.model.producto.detalles.forEach(function(element) {
        adicionalesUsadosLocal[element.adicional.id] = 0;
      });
    }
    this.model.detalles.forEach(function(detalle) {
      adicionalesUsadosLocal[detalle.tipoProductoAdicional.adicional.id]++;
      if (detalle.adicional) {
        productosAdicionalesUsados[detalle.adicional.id] = productosAdicionalesUsados[detalle.adicional.id] || 0;
        productosAdicionalesUsados[detalle.adicional.id]++;
      }
    });
    return productosAdicionalesUsados;
  }

  function onSelectAdicional(detalle) {
    let productosUtilizados = {};
    let productosAdicionalesUsados = this.localModel.productosAdicionalesUsados;

    productosAdicionalesUsados[detalle.adicional.id] = productosAdicionalesUsados[detalle.adicional.id] || 0;
    productosAdicionalesUsados[detalle.adicional.id]++;
    this.model.detalles.forEach(function(detalle) {
      if (detalle.adicional) {
        productosUtilizados[detalle.adicional.id] = detalle.adicional;
      }
    });
    this.localModel.productosUtilizados = productosUtilizados;
    if (detalle.adicional.precio) {
      detalle.monto = detalle.adicional.precio.monto;
    }
  }

  this.onSelectTipoAdicional = onSelectTipoAdicional.bind(this);

  function onSelectTipoAdicional(detalle) {
    if (detalle.tipoProductoAdicional) {
      this.localModel.adicionalesUsados[detalle.tipoProductoAdicional.adicional.id]++;
      if (detalle.tipoProductoAdicional.adicional.tipo.value !== 'Clasificador') {
        detalle.adicional = null;
      }
    }
  }

  this.loadProductosAdicionales = loadProductosAdicionales.bind(this);

  function loadProductosAdicionales(id) {
    if (this.localModel.mostrarAdicionales[id] === undefined) {
      this.localModel.mostrarAdicionales[id] = true;
    } else if (this.localModel.mostrarAdicionales[id]) {
      this.localModel.mostrarAdicionales[id] = false;
      return;
    } else {
      this.localModel.mostrarAdicionales[id] = true;
      return;
    }

    let productosPorAdicional = this.localModel.productosPorAdicional;
    if (productosPorAdicional[id] !== undefined) return;

    let filter = Filter.path('adicional.id').eq(id);

    $ngRedux.dispatch(rest.actions.productosAdicionales.get({ filter: JSON.stringify(filter) }, {}, (err, data) => {
      if (!err && data) {
        productosPorAdicional[id] = data;
      } else if (err) {
        ngNotify.set(err.message, 'warn');
      }
    }));
  }



  this.muchasCombinaciones = muchasCombinaciones.bind(this);

  function muchasCombinaciones() {
    ngNotify.set(this.translations['Existen demasiadas combinaciones'], 'warn');
  }

  function renderTipoProductoAdicional(item) {
    var display = `${item.adicional.nombre}`;
    if (item.obligatorio) {
      display = display + '<small><strong>*</strong></small>';
    }
    return display;
  }

  function renderProductoAdicional(item) {
    return `${item.nombre}`;
  }

  function filterProducto(item) {
    return !this.localModel.productosUtilizados[item.id];
  }

  /**
   * Se encarga de traer el backend la lista de servicios a mostrar.
   *
   * @param {string} query
   */
  function loadProductos(query) {
    let filter = Filter.path('precio.id').isNull();

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  function loadAdicional(query, detalle) {
    console.log(detalle);
    if (!detalle.tipoProductoAdicional) {
      return;
    }
    let filter = Filter.path('adicional.id').eq(detalle.tipoProductoAdicional.adicional.id);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  function newDetalle() {
    const self = this;
    this.localModel.payloadNuevoDetalle = {monto: 0};
    console.log("[this] ", this);
    CustomModal.open({
      title: 'Nuevo detalle de precio',
      size: 'lg',
      templateUrl: nuevoDetalle,
      vm: this,
      detalle: this.localModel.payloadNuevoDetalle,
      ok: function() {
        // Mandar solo ids de adicional y tipo de adicional
        if (self.localModel.payloadNuevoDetalle.adicional) {
          self.localModel.payloadNuevoDetalle.adicional = { id: self.localModel.payloadNuevoDetalle.adicional.id };
        }
        self.localModel.payloadNuevoDetalle.tipoProductoAdicional = self.localModel.payloadNuevoDetalle.tipoProductoAdicional.id;
        // Request para guardar el detalle de precio
        $ngRedux.dispatch(rest.actions.crearPrecioDetalle({id: self.model.id}, { body: JSON.stringify(self.localModel.payloadNuevoDetalle) },
          (err, data) => {
            if (!err && data && data.id) {
              self.model.detalles.push(data);
              ngNotify.set(self.translations['Nuevo detalle de precio guardado'], 'success');
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
      }

    });
  }

  function editDetalle(detalle) {
    const self = this;
    this.localModel.payloadEditDetalle = Object.assign({}, detalle);
    console.log("[this] ", this);
    CustomModal.open({
      title: 'Actualizar detalle de precio',
      size: 'lg',
      templateUrl: nuevoDetalle,
      vm: this,
      detalle: this.localModel.payloadEditDetalle,
      ok: function() {
        // Mandar solo ids de adicional y tipo de adicional
        if (self.localModel.payloadEditDetalle.adicional) {
          self.localModel.payloadEditDetalle.adicional = { id: self.localModel.payloadEditDetalle.adicional.id };
        }
        self.localModel.payloadEditDetalle.tipoProductoAdicional = self.localModel.payloadEditDetalle.tipoProductoAdicional.id;
        // Request para actualizar el detalle de precio
        $ngRedux.dispatch(rest.actions.editarPrecioDetalle({id: self.model.id}, { body: JSON.stringify(self.localModel.payloadEditDetalle) },
          (err, data) => {
            if (!err && data && data.id) {
              // Actualizar en el array de detalles el que fue editado
              self.model.detalles = self.model.detalles.reduce((detalles, detalle) => {
                const toPush = detalle.id === data.id ? data : detalle;
                detalles.push(toPush);
                return detalles;
              }, []);
              ngNotify.set(self.translations['Detalle de precio actualizado'], 'success');
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
      }

    });
  }

  function deleteDetalle(detalle) {
    const self = this;
    CustomModal.open({
      title: 'Eliminar detalle de precio',
      message: '¿Seguro que desea eliminar el detalle de precio?',
      ok: function() {
        $ngRedux.dispatch(rest.actions.eliminarPrecioDetalle({ id: detalle.id }, {}, (err, data) => {
          if (!err) {

            if (detalle.tipoProductoAdicional) {
              self.localModel.adicionalesUsados[detalle.tipoProductoAdicional.adicional.id]--;
            }
            if (detalle.adicional && self.localModel.productosAdicionalesUsados[detalle.adicional.id]) {
              self.localModel.productosAdicionalesUsados[detalle.adicional.id]--;
            }

            _.remove(self.model.detalles, detalle);

            ngNotify.set('Detalle de precio eliminado correctamente', 'success');

          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });

  }

  function toggleDetalles() {
    if (this.localModel.mostrarDetalles) {
      this.generarDetalles();
    }
  }

  function generarDetalles() {
    let combinaciones = [];
    this.localModel.combinaciones = combinaciones;

    let tiposAdicionalesMap = {};
    this.model.detalles.forEach(function(detalle) {
      tiposAdicionalesMap[detalle.tipoProductoAdicional.id] = tiposAdicionalesMap[detalle.tipoProductoAdicional.id] || { objeto: detalle.tipoProductoAdicional, opciones: [] };
      tiposAdicionalesMap[detalle.tipoProductoAdicional.id].opciones.push(detalle);
    });

    let tiposAdicionalesIndices = Object.keys(tiposAdicionalesMap);

    let obligatoriosArray = [];
    tiposAdicionalesIndices.forEach(function(id) {
      if (tiposAdicionalesMap[id].objeto.obligatorio) {
        obligatoriosArray.push(id);
      }
    });

    for (let combo of generateCombinations(tiposAdicionalesIndices)) {
      let isSuperset = obligatoriosArray.every(function(val) { return combo.indexOf(val) >= 0; });
      if (!isSuperset) {
        continue;
      }

      let arrayLength = 1;
      let matriz = new Array(combo.length);
      for (let i in combo) {
        arrayLength *= tiposAdicionalesMap[combo[i]].opciones.length;
      }

      for (let i in combo) {
        matriz[i] = new Array(arrayLength);
      }

      for (let i in combo) {
        for (let j = 0; j < arrayLength; j++) {
          let indice = j % tiposAdicionalesMap[combo[i]].opciones.length;
          matriz[i][j] = tiposAdicionalesMap[combo[i]].opciones[indice];
        }
      }

      for (let j = 0; j < arrayLength; j++) {
        let nombre = 'Base';
        let importe = this.model.monto;
        for (let i in combo) {
          let parte = matriz[i][j].adicional ? matriz[i][j].adicional.nombre : matriz[i][j].tipoProductoAdicional.adicional.nombre;
          nombre += ` | ${parte}`;
          importe += matriz[i][j].monto;
        }
        combinaciones.push({ nombre, importe });
      }
    }

    function* generateCombinations(arr) {
      function* doGenerateCombinations(offset, combo) {

        yield combo;
        for (let i = offset; i < arr.length; i++) {
          yield* doGenerateCombinations(i + 1, combo.concat(arr[i]));
        }
      }
      yield* doGenerateCombinations(0, []);
    }

    this.renderMoneda = renderMoneda.bind(this);
    function renderMoneda(moneda) {
      return moneda.value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/precios/form/form.component.js